import { create } from "zustand";

// Define the types for the state
interface HotelDetailStore {
  checkIn: string;
  checkOut: string;
  passenger: string;
  policies: string;
  totalPrice: { price: string; currency: string } | null;
  isGetting: boolean;
  availableRooms: number;
  minPrice: number;
  setPolicies: (policies: string) => void;
  setIsGetting: (isGetting: boolean) => void;
  setCheckIn: (checkIn: string) => void;
  setCheckOut: (checkOut: string) => void;
  setPassenger: (passenger: string) => void;
  setAvailableRooms: (setAvailableRooms: number) => void;
  setMinPrice: (minPrice: number) => void;
  setTotalPrice: (totalPrice: { price: string; currency: string } |null) => void;
}

// Create the Zustand store
const useHotelDetailStore = create<HotelDetailStore>((set) => ({
  checkIn: "",
  checkOut: "",
  passenger: "",
  totalPrice: null,
  isGetting: false,
  policies: "",
  availableRooms: 0,
  minPrice: 0,
  setIsGetting: (isGetting) => set(() => ({ isGetting })),
  setPolicies: (policies) => set(() => ({ policies })),
  setCheckIn: (checkIn) => set(() => ({ checkIn })),
  setCheckOut: (checkOut) => set(() => ({ checkOut })),
  setPassenger: (passenger) => set(() => ({ passenger })),
  setTotalPrice: (totalPrice) => set(() => ({ totalPrice })),
  setMinPrice: (minPrice) => set(() => ({ minPrice })),
  setAvailableRooms: (availableRooms) => set(() => ({ availableRooms })),
}));

export default useHotelDetailStore;
